'use client';

import {
  Grid as GridRoot,
  type GridProps,
  type GridBaseProps,
  gridClasses,
} from './Grid';
import {
  GridItem,
  type GridItemProps,
  type GridItemBaseProps,
  gridItemClasses,
} from './GridItem';

const Grid = Object.assign(GridRoot, {
  Item: GridItem,
});

export {
  Grid,
  gridClasses,
  gridItemClasses,
  type GridProps,
  type GridBaseProps,
  type GridItemProps,
  type GridItemBaseProps,
};
